module.exports = __webpack_public_path__ + "static/media/foto5.6bff5c23.JPG";